import { Text } from "@chakra-ui/react";

export default function NoMatch() {
  return <Text>Nothing to see here</Text>;
}
